/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { borderRadius } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const BranchGraphic = styled.div({
  display: 'flex',
  alignItems: 'center',
  padding: `${token('space.400')} 0`,
  '> :first-child': {
    flex: '0 0 auto',
    marginRight: token('space.400'),
  },
});

export const BranchLabels = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  /* We need to allow the container with labels to be narrow, so 'min-width' should be 0,
     but IE11 doesn't support it due to a bug, so using next minimal value of 1px */
  minWidth: '1px',
  height: '60px',
  '> :first-child': {
    marginTop: '-5px',
  },
  '> :last-child': {
    marginBottom: '-5px',
  },
});

export const BranchLabelWrapper = styled.div({
  background: token('color.background.input'),
  padding: `${token('space.025')} ${token('space.050')}`,
  borderRadius: `${borderRadius()}px`,
  maxWidth: '100%',
  boxSizing: 'border-box',
});

export const BranchLabel = styled.div({
  display: 'flex',
  alignItems: 'center',
  fontFamily: token('font.family.code'),
  '> span': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
});
